const $ = jQuery;
require('datatables.net')
const dt = require( 'datatables.net-dt' )

const _ = require('lodash')

const dtfc = require( 'datatables.net-fixedcolumns-dt' )

import {format, parse, parseISO, endOfMonth, endOfYear} from 'date-fns';

export class Filters {

    

   
    // constructor(public elements: NodeListOf<Element>, public view: string) {
    constructor(elements) {
        
        // console.log(elements)
        this.params = {
            filterByFormula: '',
            post_id: null
        }

        this.elements = elements;
        this.init();
        
        // this.params.append('view', this.view);
    }

    init() {

        window.filters = {
            params: {}
        }

        var _this = this

        this.dateFilterOnSelect();

        // console.log(this.elements)
        for (let element of this.elements) {
            if(this.isDropdown(element)) {
                this.dropdownFilter(element);

                //TODO
                element.addEventListener('toggle', (e) => {
                    if(element.hasAttribute('open')) {
                        this.elements.forEach((detail) => {
                            if(detail !== element) {
                                detail.removeAttribute('open');
                            }
                        })
                    }
                });
            } else if(element.classList.contains('Select')) {
                this.selectFilter(element);
            } else if ( element.classList.contains('filter-menu')) {

                for (let element of this.elements) {

                    let param = element.getAttribute('data-param')
                    let compare = $('option:selected', element).val()
                    let value = $('.inline-filter-search', element).val()

                    delete _this.params[param]
                    delete _this.params[`!_${param}`]
                    if ( element.classList.contains('active') ) {
                        
                        if ( 'eq' == compare ) {
                            _this.params[param] = value
                        } else {
                            _this.params[`!_${param}`] = value
                        }
                        
                    }
                }

            }
        }

        
        if($('.dropdown-filter-toggle').length > 0) {
            $('.dropdown-filter-toggle').click(function (e) {
                $(this).toggleClass('is-active');
                $(this).parents('.dropdown-filter').find('.dropdown-filter-content').toggleClass('is-active');
            });
        }


        $('.dropdown-filter').each(function() {

            var t = this

            window.addEventListener('click', function(e){   
              if (t.contains(e.target)) {
                // Clicked in box
                // console.log('in')
              } else{
                // Clicked outside the box
                // console.log('out')
                _this.dropdownClose(t);
              }
            });
        })


        this.downgradedFilters()


        // this.dropdownFilter()

        // console.log('data-soft-filter-active::',$('.filters-container[data-soft-filter-active] form').first())
        $('.filters-container[data-soft-filter-active] form').trigger('submit')

    }


    downgradedFilters() {

        $('.inline-filter-search').on('change', function() {
            $(document).on('change', '.inline-filter-compare', _.debounce( _.bind(this.inlineFilterAction, this), 200 ) );
        })


        window.addEventListener('click', function(e){   
          for ( let element of document.getElementsByClassName('filter-menu') ){
            if (! element.contains(e.target) ) 
                element.parentElement.classList.remove('inline-filter-on')    
            }
        });

        $(document).on('keyup', '.inline-filter-search', _.debounce( _.bind(this.inlineFilterAction, this) , 1000 ) )

        $(document).on('change', '.inline-filter-compare', _.debounce( _.bind(this.inlineFilterAction, this), 200 ) )
    }

    inlineFilterAction(e) {

        const _this = this

        let $i = $(e.currentTarget)
        let val = $i.val()

        if ( val ) {
            $i.closest('.DataTable_cell_head').addClass('active')
        } else {
            $i.closest('.DataTable_cell_head').removeClass('active')
        }



        for (let element of this.elements) {
            let param = element.getAttribute('data-param')
            let compare = $('option:selected', element).val()
            let value = $('.inline-filter-search', element).val()

            delete _this.params[param]
            delete _this.params[`!_${param}`]
            if ( element.parentElement.classList.contains('active') ) {

                if ( 'eq' == compare ) {
                    _this.params[param] = value
                } else {
                    _this.params[`!_${param}`] = value
                }
            
            }
        }

        // console.log( this.params )

        let dt_id = $(this.elements[0]).attr('data-dt-id')
        this.params['dt_id'] = dt_id

        this.params['env'] = BRYTER.envId

        this.render('?' + this.params.toString(), this.params);

    }


    isDropdown(element) {
        if(element.classList.contains('dropdown-filter')) {
            return true;
        }
    }

    selectFilter(element) {
        element.addEventListener('change', (e) => {

            let el = (e.target);
            let value = el.value;

            this.params.delete('field');
            this.params.delete('direction');

            this.params.append('field', 'created_time');
            this.params.append('direction', value);

            this.render('?' + this.params.toString());
        })
    }

    dropdownFilter(element) {
        let form = element.querySelector('form');

        if (form) {
            this.dropdownFilterSubmit(element, form);
            this.dropdownFilterReset(element, form);
        }
    }

    dateFilterOnSelect() {
        const _this = this;

        $(document).on('startDateOnSelect', function(event, selectedDate) {
            _this.render('?' + window.filters.params.toString(), window.filters.params);
        });

        $(document).on('endDateOnSelect', function(event, selectedDate) {
            _this.render('?' + window.filters.params.toString(), window.filters.params);
        });
    }

    dropdownFilterSubmit(element, form) {
        const _this = this
        form.onsubmit = (e) => {
            e.preventDefault();

            // this.dropdownResetOthers(element);
            const data = new FormData(form);
            const pairs = Array.from(data.entries());

            // console.log('pairs', pairs)

            // console.log(element)
            let dt_id = element.getAttribute('data-dt-id');

            /*
            * Make sure we're trying to filter a data view
             */
            if(dt_id) {
                window.filters.params['dt_id'] = dt_id

                // console.log('dropdownFilterSubmit this.params', this.params)
                //TODO remove when refactored
                // console.log('before pairs', window.filters.params)
                for (let pair of pairs) {
                    // this.params.delete('filterByFormula');
                    // this.params.append('filterByFormula', escape("({"+ pair[0] + "}='" + pair[1] + "')"));

                    // _this.params.filterByFormula = escape("({"+ pair[0] + "}='" + pair[1] + "')")
                    window.filters.params[pair[0]] = encodeURIComponent(pair[1]);

                    _this.render('?' + this.params.toString(), window.filters.params);
                }
            }
        

            this.dropdownClose(element);
            this.dropdownText(element, pairs);
            this.dropdownResetRemoveDisabledAttr(element);

        }
        // setTimeout(function(){

        // }, 5000)
    }

    dropdownResetOthers(element) {

        this.elements.forEach((item) => {
            if (this.isDropdown(item) && item != element) {
                const summary = item.querySelector('summary');
                const defaultLabel = item.getAttribute('data-default-label');

                $('.filters-count', item).remove()

                if(summary) {
                    summary.innerText = defaultLabel;
                }
                if ( item.querySelector('form') !== null ) {
                    item.querySelector('form').reset();
                }
            }
        });
    }

    dropdownFilterReset(element, form) {

        const _this = this

        const summary = element.querySelector('.summary-label');
        const defaultLabel = element.getAttribute('data-default-label');

        const resetBtn = form.querySelector('button[type="reset"]');



        if(resetBtn && summary) {
            resetBtn.addEventListener('click', (e) => {

                $(document).trigger('resetDatePickers', { type: 'reset', element });
                
                const column = $(e.currentTarget).closest('form').attr('data-column');

                for ( let i in _this.params ) {
                    history.replaceState(
                            null, '', take_param('soft-filter['+i+']').search + location.hash)
                    if ( i == column ) {
                        delete _this.params[i]
                        $(`input[name="${i}"]`).prop('checked', 0);
                        $(`input[name="${i}"]`).removeAttr('checked');
                    }
                }

                $('.filters-container[data-soft-filter-active]').removeAttr('data-soft-filter-active')

                // summary.innerText = defaultLabel;
                if ( element.querySelector('.filters-position-top .summary-label') )
                    element.querySelector('.filters-position-top .summary-label').innerText = defaultLabel

                form.reset();

                this.dropdownClose(element);

                this.dropdownResetAddDisabledAttr(element);

                
                
                $('.dropdown-filter').each(function(){
                    let name = $('input[type=radio]', this).first().attr('name'),
                        checked = $('input[type=radio]:checked', this).length

                    if ( _this.params.hasOwnProperty(name) ) {
                        if ( ! checked ) {
                            // console.log('name::', name)
                            delete _this.params[name]
                        }
                    }
                })

                // console.log(_this.params);

                // let url_params = new URLSearchParams(location.search);
                // console.log('url_params::', url_params, location.search)
                // url_params.delete('soft-filter')
                // console.log('url_params:::', url_params)

                // alert(2)
                // console.log(_this.params)

                let dt_id = $(element).closest('.dropdown-filter').attr('data-dt-id')
                let params = _this.params
                params['dt_id'] = dt_id

                /*
                * Only run this if it is a data view
                 */
                if(dt_id) {
                    _this.render('?' + _this.params.toString(), params);
                }
            });
        }

        function take_param(key) {
            var params = new Map(location.search.slice(1).split('&')
                .map(function(p) { return p.split(/=(.*)/) }))   
            var value = params.get(key)
            params.delete(key)
            var search = Array.from(params.entries()).map(
                function(v){ return v[0]+'='+v[1] }).join('&')
            return {search: search ? '?' + search : '', value: value}
        }
    }

    dropdownResetRemoveDisabledAttr(element) {
        const resetBtn = element.querySelector('button[type=reset]');

        if(resetBtn) {
            resetBtn.removeAttribute('disabled');
        }
    }

    dropdownResetAddDisabledAttr(element) {
        const resetBtn = element.querySelector('button[type=reset]');

        if(resetBtn) {
            resetBtn.setAttribute('disabled', '');
        }
    }

    dropdownClose(element) {
        element.removeAttribute('open');
    }

    dropdownText(element, pairs) {
        // console.log('pairs)
        const summary = element.querySelector('summary');
        if ( pairs.length ) {
            const value = pairs[0][1]; //TODO


            if(summary) {
                // summary.innerText = $('input[name="'+pairs[0][0]+'"]:checked').attr('data-label')
            }
        }
    }

    render(queryString, params) {
        const ajaxContent = document.getElementById('ajax-content');
        // console.log(<HTMLInputElement>)
        // const postId = (<HTMLInputElement>document.getElementById('bryter_post_id')).value;
        const postId = window.BRYTER.postId
        const homeUrl = window.BRYTER.homeUrl;
        let url;
        const _this = this
        
        url = window.location.href + queryString;
        // console.log(params)
        params['post_id'] = postId

        this.params = params

        if(document.querySelector('body').classList.contains('single-bryter-dashboard')) return;

        $.ajax({
            url: BRYTER.ajaxUrl,
            data: {
                action: 'tableFilter',
                params: params,
                env: BRYTER.envId,
            },

            success: function( html ) {
                // console.log($('.DataTableWrapper-' + params['dt_id']))
                // console.log(params)

                $('.DataTableWrapper-' + params['post_id'] + ' tbody').html($(html).find('.DataTableWrapper tbody').html())

                // params.forEach( (i, el) => {
                for ( var param_key in params ) {
                    if ( $(`input[type=radio][name="${param_key}"]`).length ) {
                        // console.log('label::', $(`input[type=radio][name="${param_key}"]`).parents('.dropdown-filter'))
                        if ( $(`input[type=radio][name="${param_key}"]`).parents('.dropdown-filter').find('.filters-count').length ) {
                            $(`input[type=radio][name="${param_key}"]`).parents('.dropdown-filter').find('.filters-count').text('1')
                        } else {
                            $(`input[type=radio][name="${param_key}"]`).parents('.dropdown-filter').find('.summary-label').prepend('<span class="filters-count">1</span> ')                            
                        }
                        
                    }
                }   

                _this.params = params
            }
        })
    }
}

document.addEventListener('readystatechange', function() {
    if (document.readyState === 'complete') {
        LightTableFilter.init();
    }
});

var LightTableFilter = (function(Arr) {

    let _input;


    function _onInputEvent(e) {
        _input = e.target;
        // console.log('_input::', _input)
        var tables = [ document.getElementById(_input.getAttribute('data-table')) ];
        // console.log('tables::', tables)
        Arr.forEach.call(tables, function(table) {
            Arr.forEach.call(table.tBodies, function(tbody) {
                Arr.forEach.call(tbody.rows, _filter);
            });
        });
    }

    function _filter(row) {
        // console.log(row)
        var text = row.getAttribute('data-searchable-values').toLowerCase(), val = _input.value.toLowerCase();
        row.style.display = text.indexOf(val) === -1 ? 'none' : 'table-row';

    }

    function _onResetBtnClickEvent(e) {
        _input = e.target;
        _input.parentElement.previousElementSibling.value = ''
        const inputEvent = new Event('input');
        _input.parentElement.previousElementSibling.dispatchEvent(inputEvent)
        // console.log(_input.parentElement.previousElementSibling )
    }   

    return {
        init: function() {
            var inputs = document.getElementsByClassName('search-input-field');
            var resetBtns = document.getElementsByClassName('search-input-reset');
            // var selects = document.getElementsByClassName('select-table-filter');
            Arr.forEach.call(inputs, function(input) {
                input.oninput = _onInputEvent;
            });
            Arr.forEach.call(resetBtns, function(btn) {
                btn.onclick  = _onResetBtnClickEvent;
            });

            // console.log('Arr::', Arr)

        }
    };
})(Array.prototype);